import React from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import * as ETVConstants from '../ETVConstants';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ETVPage from '../tools/ETVPage';
import ETVTable from '../tools/ETVTable';

class AuditLog extends React.Component {
  state = {
    isLoading: false,
    isLoaded: false,
    list: [],
    filteredList: [],
    selectedUser: '',
    selectedDate: '',
    searchLog: '',
    uniqueUsers: [],
    uniqueDates: [],
  };

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ isLoading: true });
    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    const url = `${ETVConstants.getServerBase()}/audit_log?user_id=${this.props.user_id}`;
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((response) => response.json())
      .then((logs) => {
        const list = logs.list;

        // Extract unique users and dates
        const uniqueUsers = Array.from(new Set(list.map((item) => item.user_name)));
        const uniqueDates = Array.from(
          new Set(list.map((item) => new Date(item.date_time).toLocaleDateString()))
        );     

        this.setState({
          list,
          filteredList: list,
          uniqueUsers,
          uniqueDates,
          isLoaded: true,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoading: false });
      });
  }

  handleFilterChange = () => {
    const { list, selectedUser, selectedDate, searchLog } = this.state;

    const filteredList = list.filter((item) => {
      const matchesUser = selectedUser ? item.user_name === selectedUser : true;
      const matchesDate = selectedDate
        ? new Date(item.date_time).toLocaleDateString() === selectedDate
        : true;
      const matchesLog = searchLog
        ? item.log.toLowerCase().includes(searchLog.toLowerCase())
        : true;

      return matchesUser && matchesDate && matchesLog;
    });

    this.setState({ filteredList });
  };

  handleUserChange = (e) => {
    this.setState({ selectedUser: e.target.value }, this.handleFilterChange);
  };

  handleDateChange = (e) => {
    this.setState({ selectedDate: e.target.value }, this.handleFilterChange);
  };

  handleLogSearchChange = (e) => {
    this.setState({ searchLog: e.target.value }, this.handleFilterChange);
  };

  showDate(dateStr) {
    const d = new Date(dateStr);
	return <Typography variant='body2' noWrap sx={{fontStyle:'italic'}}>{d.toLocaleString()}</Typography>;
  }

  createTable() {
	return <ETVTable
	  title="Audit entries"
	  data={this.state.filteredList}
	  search={false}
	  pageSize={10}
	  options={{tableLayout:'fixed'}}
	  columns={[
		{title:ETVConstants.trans('date_time'),field:'date_time',width:210,render:(row)=>this.showDate(row.date_time)},
		{title:ETVConstants.trans('user'),field:'user_name',width:180,cellStyle:{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}},
		{title:ETVConstants.trans('log'),field:'log',cellStyle:{whiteSpace:'normal',overflowWrap:'anywhere'}},
	  ]}
	/>;
  }

  render() {
    const { isLoading, uniqueUsers, uniqueDates, selectedUser, selectedDate, searchLog } = this.state;

    return (
	  <ETVPage width="standard" icon={<VerifiedUserIcon fontSize="large"/>} title={ETVConstants.trans('audit_logs')} description="Review account activity and narrow the results using the filters below." loading={isLoading} sx={{minHeight:'60vh'}}>
		{!isLoading && <>
          <div style={{ marginBottom:'22px', display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(210px, 1fr))', gap:'12px' }}>
            {/* User Dropdown */}
            <TextField
              select
              value={selectedUser}
              onChange={this.handleUserChange}
              label={ETVConstants.trans('filter_by_user')}
              variant="outlined"
			  style={{ minWidth: '200px' }}
            >
              <MenuItem value="">{ETVConstants.trans('all_users')}</MenuItem>
              {uniqueUsers.map((user) => (
                <MenuItem key={user} value={user}>
                  {user}
                </MenuItem>
              ))}
            </TextField>

            {/* Date Dropdown */}
            <TextField
              select
              value={selectedDate}
              onChange={this.handleDateChange}
              label={ETVConstants.trans('filter_by_date')}
              variant="outlined"
			  style={{ minWidth: '200px' }}
            >
              <MenuItem value="">{ETVConstants.trans('all_dates')}</MenuItem>
              {uniqueDates.map((date) => (
                <MenuItem key={date} value={date}>
                  {date}
                </MenuItem>
              ))}
            </TextField>

            {/* Log Search */}
            <TextField
              value={searchLog}
              onChange={this.handleLogSearchChange}
              label={ETVConstants.trans('search_log')}
              variant="outlined"
              fullWidth
            />
          </div>
          {this.createTable()}
		</>}
	  </ETVPage>
    );
  }
}

export default AuditLog;
